import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom';
import { Heading, Card, CardHeader, CardBody, Button } from 'penguinfinance-uikit2'
import FlexLayout from 'components/layout/Flex';

const StyledFarmStakingCard = styled(Card)`
  background: ${({ theme }) => theme.isDark && '#272044'};
  border-radius: 10px;
  max-width: 1300px;
  width: 100%;
  margin-top: 4px;
  margin-bottom: 16px;
  overflow: unset;

  @media (min-width: 768px) {
    margin-top: 8px;
    margin-bottom: 60px;
  }
  @media (min-width: 1200px) {
    margin-top: 40px;
    margin-bottom: 20px;
  }
`

const Title = styled(Heading)`
  font-family: Kanit;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 48px;
  color: white;

  @media (min-width: 768px) {
    font-size: 28px;
    line-height: 56px;
  }
  @media (min-width: 968px) {
    font-size: 36px;
    line-height: 56px;
  }
  @media (min-width: 1200px) {
    font-size: 44px;
    line-height: 75px;
  }
`

const StyledCardHeader = styled(CardHeader)`
  padding-top: 0px;
  padding-bottom: 0px;
  display: flex;
  justify-content: center;
  background: ${({ theme }) => (theme.isDark ? '#392771' : '#392771')};
  border-radius: 10px 10px 0 0;

  @media (min-width: 968px) {
    padding-left: 56px;
    justify-content: center;
  }
`

const StyledCardBody = styled(CardBody)`
  padding: 28px 16px;
  background: #564BAB;
  border-radius: 0 0 10px 10px;

  @media (min-width: 768px) {
    padding: 28px 20px;
  }
  @media (min-width: 968px) {
    padding: 0px 40px;
  }
  @media (min-width: 1200px) {
    padding: 0px 56px;
  }
`;

const StyledFlexLayout = styled(FlexLayout)`
  margin-left: -8px;
  justify-content: space-around;
  margin-right: -8px;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;

  @media (min-width: 640px) {
    margin-left: -16px;
    margin-right: -16px;
  }

  @media (min-width: 968px) {
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
  }
  @media (min-width: 1400px) {
    margin-left: -24px;
    margin-right: -24px;
  }

  @media (max-width: 576px) {
    margin-left: 0px;
    margin-right: 0px;
  }

  & > * {
    margin-left: 16px;
    margin-right: 16px;
    width: 320px;
    max-width: 320px;
    margin-bottom: 0;
    @media (max-width: 576px) {
      margin-left: 0px;
      margin-right: 0px;
      max-width: 100%;
      min-width: unset;
    }

    @media (min-width: 640px) {
      min-width: unset;
      max-width: 320px;
      width: unset;
    }
    @media (min-width: 968px) {
      min-width: unset;
      width: 260px;
      max-width: 260px;
      width: 100%;
    }
    @media (min-width: 1200px) {
      min-width: unset;
      width: 320px;
      max-width: 320px;
      width: 100%;
    }
  }
`;

const EmperorImg = styled.img`
`;

const ArenaImg = styled.img`
`;

const PuffyGameImageWrapper = styled.div`
  position: relative;
  height: 160px;

  @media (min-width: 968px) {
    height: 144px;
  }
  @media (min-width: 1200px) {
    height: 160px;
  }
`;

const PuffyGameImg = styled.img`
  position: absolute;
  min-width: 360px;
  left: -48px;

  @media (min-width: 968px) {
    left: -48px;  
    min-width: 320px;
  }
  @media (min-width: 1200px) {
    left: -48px;
    min-width: 360px;
  }
`;

const LayoutItem = styled.div`
  position: relative;
`;

const ArenaGameCard = styled.div`
  background: #D13E37;
  box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  padding: 0 20px 16px;

  @media (min-width: 968px) {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    border-radius: 0 0 10px 10px;
  }
`;

const ArenaGameCardContent = styled.div`
  background: #EE3E40;
  box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.4);
  border-radius: 0 0 10px 10px;
  padding: 16px 8px 8px;

  @media (min-width: 1200px) {
    padding: 32px 8px 8px;
  }
`;

const EmperorGameCard = styled(ArenaGameCard)`
`;

const EmperorGameCardContent = styled(ArenaGameCardContent)`
  position: relative;
  padding-bottom: 108px;

  @media (min-width: 1200px) {  
    padding-bottom: 120px;
  }
`;

const MyProfileImg = styled.img`
  margin-top: 32px;
  width: 360px;

  @media (min-width: 968px) {  
    margin-top: 12px;
  }
`;

const ProfileButton = styled.div`
  cursor: pointer;
  background: #392771;
  border-radius: 8px;
  width: 100%;
  max-width: 200px;
  margin-left: auto;
  margin-right: auto;
  height: 48px;
  font-size: 28px;
  font-family: 'Kanit';
  font-weight: 500;
  text-decoration: underline;
  color: white;
  text-align: center;
  padding: 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 8px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 968px) {  
    font-size: 24px;
    height: 40px;
    margin-bottom: 24px;
  }
  @media (min-width: 1200px) {
    font-size: 28px;
    height: 56px;
  }
`;

const ArenaContent = styled.div`
  position: relative;
`;

const PlayNowButton = styled(Button)`
  background: #EE3E40;
  border-radius: 8px;
  font-size: 24px;
  font-weight: 500;
  position: absolute;
  bottom: 16px;
  width: 82%;
  left: 14px;
  height: 36px;
  
  @media (min-width: 576px) {  
    height: 40px;
  }
  @media (min-width: 968px) {
    width: 80%;
    font-size: 22px;
    bottom: 12px;
    height: 36px;
  }
  @media (min-width: 1200px) {
    width: 82%;
    font-size: 28px;
    bottom: 16px;
    height: 44px;
  }
`;

const EmperorPlayButton = styled.div`
  cursor: pointer;
  background: #564BAB;
  position: relative;
  z-index: 1;
  border-radius: 10px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  height: 36px;
  font-size: 24px;
  font-family: 'Kanit';
  font-weight: 400;
  color: white;
  text-align: center;
  padding: 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 8px;
  box-shadow: -3px -1px 0px 0px rgb(14 14 138 / 40%) inset;

  @media (min-width: 576px) {  
    height: 40px;
  }
  @media (min-width: 968px) {  
    font-size: 22px;
    height: 36px;
  }
  @media (min-width: 1200px) {
    margin-top: 12px;
    font-size: 28px;
    height: 44px;
  }
`;

const EmperorBattleBackImg = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
`;

const GamesCard = () => {
  const history = useHistory();

  const handlePlayEmperor = () => {
    history.push('/emperor');
  };

  const handlePlayArena = () => {
    history.push('/arena');
  }

  return (
    <StyledFarmStakingCard>
      <StyledCardHeader>
        <Title size="xl" mb="0px" color="primary">
          Our dapps
        </Title>
      </StyledCardHeader>
      <StyledCardBody>
        <StyledFlexLayout>
          <LayoutItem>
            <ArenaGameCard>
              <ArenaGameCardContent>
                <ArenaContent>
                  <ArenaImg src={`${process.env.PUBLIC_URL}/images/home-v2/game/penguin_arena.png`} />
                  <PlayNowButton onClick={handlePlayArena}>Play Now</PlayNowButton>
                </ArenaContent>
                <PuffyGameImageWrapper>
                  <PuffyGameImg src={`${process.env.PUBLIC_URL}/images/home-v2/game/puffy_game.png`} />
                </PuffyGameImageWrapper>
              </ArenaGameCardContent>
            </ArenaGameCard>
          </LayoutItem>
          <LayoutItem>
            <MyProfileImg src={`${process.env.PUBLIC_URL}/images/home-v2/game/my_profile.png`} />
            <ProfileButton>Your Profile</ProfileButton>
          </LayoutItem>
          <LayoutItem>
            <EmperorGameCard>
              <EmperorGameCardContent>
                <EmperorImg src={`${process.env.PUBLIC_URL}/images/home-v2/game/emperor-royale.png`} />
                <EmperorPlayButton onClick={handlePlayEmperor}>Play Now</EmperorPlayButton>
                <EmperorBattleBackImg src={`${process.env.PUBLIC_URL}/images/home-v2/game/battle_back.png`} />
              </EmperorGameCardContent>
            </EmperorGameCard>
          </LayoutItem>
        </StyledFlexLayout>
      </StyledCardBody>
    </StyledFarmStakingCard>
  )
}

export default GamesCard;
